import { createSlice } from "@reduxjs/toolkit";

// ---- import from local actions ----
import { fetchElevCtrlHistoryList } from "./../actions/ElevCtrlHistoryActions";


const ElevaCtrlHistorySlice = createSlice({
    name: "elevCtrlHistory",
    initialState: {
        elevCtrlHistoryList: {
          data: [],
          status: 'idle',
          error: "",
          loading: false,
      },
    },
    
    extraReducers: (builder) => {
      builder
        .addCase(fetchElevCtrlHistoryList.pending, (state) => {
          state.elevCtrlHistoryList.status = 'loading';
        })
        .addCase(fetchElevCtrlHistoryList.fulfilled, (state, action) => {
            state.elevCtrlHistoryList.status = 'idle';
            state.elevCtrlHistoryList.data = action.payload.result;
        })
        .addCase(fetchElevCtrlHistoryList.rejected, (state, action) => {
          state.elevCtrlHistoryList.status = 'rejected';
          state.elevCtrlHistoryList.error = action.error.message;
        })
    },
});


export default ElevaCtrlHistorySlice.reducer;
